import {
  ArrowFatDownIcon,
  ArrowFatLineDownIcon,
  ArrowFatLineUpIcon,
  ArrowFatUpIcon,
} from '@phosphor-icons/react';

import { useTextEditorStore } from './useTextEditorStore';

import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

interface ZOrderButtonsProps {
  elementId: string;
}

export function ZOrderButtons({ elementId }: ZOrderButtonsProps) {
  const bringToFront = useTextEditorStore((s) => s.bringToFront);
  const sendToBack = useTextEditorStore((s) => s.sendToBack);
  const bringForward = useTextEditorStore((s) => s.bringForward);
  const sendBackward = useTextEditorStore((s) => s.sendBackward);

  const buttons = [
    { label: 'Bring to front', icon: ArrowFatLineUpIcon, action: () => bringToFront(elementId) },
    { label: 'Bring forward', icon: ArrowFatUpIcon, action: () => bringForward(elementId) },
    { label: 'Send backward', icon: ArrowFatDownIcon, action: () => sendBackward(elementId) },
    { label: 'Send to back', icon: ArrowFatLineDownIcon, action: () => sendToBack(elementId) },
  ];

  return (
    <div className="flex items-center gap-0.5">
      {buttons.map((btn) => (
        <Tooltip key={btn.label}>
          <TooltipTrigger asChild>
            <button
              type="button"
              onClick={btn.action}
              aria-label={btn.label}
              className="grid size-7 place-items-center rounded-md text-foreground/70 hover:bg-muted hover:text-foreground"
            >
              <btn.icon size={14} />
            </button>
          </TooltipTrigger>
          <TooltipContent side="bottom">{btn.label}</TooltipContent>
        </Tooltip>
      ))}
    </div>
  );
}
